import _JSXStyle from "styled-jsx/style";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { colors, theme, sharedPropTypes } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { SwitchRegular } from './switch-icons.js';
class Switch extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "ref", /*#__PURE__*/createRef());
    _defineProperty(this, "handleChange", e => {
      if (this.props.onChange) {
        this.props.onChange(this.createHandlerPayload(), e);
      }
    });
    _defineProperty(this, "handleBlur", e => {
      if (this.props.onBlur) {
        this.props.onBlur(this.createHandlerPayload(), e);
      }
    });
    _defineProperty(this, "handleFocus", e => {
      if (this.props.onFocus) {
        this.props.onFocus(this.createHandlerPayload(), e);
      }
    });
    _defineProperty(this, "handleKeyDown", e => {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(this.createHandlerPayload(), e);
      }
    });
  }
  componentDidMount() {
    if (this.props.initialFocus) {
      this.ref.current.focus();
    }
  }
  createHandlerPayload() {
    return {
      value: this.props.value,
      name: this.props.name,
      checked: !this.props.checked
    };
  }
  render() {
    const {
      'aria-label': ariaLabel,
      checked = false,
      className,
      disabled,
      error,
      label,
      name,
      tabIndex,
      valid,
      value,
      warning,
      dense,
      dataTest = 'dhis2-uicore-switch',
      role = 'switch'
    } = this.props;
    const classes = cx({
      checked,
      disabled,
      valid,
      error,
      warning,
      dense
    });
    return /*#__PURE__*/React.createElement("label", {
      "data-test": dataTest,
      className: _JSXStyle.dynamic([["3097670863", [colors.grey900, theme.disabled, theme.focus]]]) + " " + (cx(className, {
        disabled,
        dense
      }) || "")
    }, /*#__PURE__*/React.createElement("input", {
      "aria-label": ariaLabel,
      type: "checkbox",
      role: role,
      ref: this.ref,
      name: name,
      value: value,
      checked: checked,
      disabled: disabled,
      tabIndex: tabIndex,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onBlur: this.handleBlur,
      className: _JSXStyle.dynamic([["3097670863", [colors.grey900, theme.disabled, theme.focus]]])
    }), /*#__PURE__*/React.createElement("div", {
      className: _JSXStyle.dynamic([["3097670863", [colors.grey900, theme.disabled, theme.focus]]]) + " " + (cx('icon', {
        dense
      }) || "")
    }, /*#__PURE__*/React.createElement(SwitchRegular, {
      className: classes
    })), label, /*#__PURE__*/React.createElement(_JSXStyle, {
      id: "3097670863",
      dynamic: [colors.grey900, theme.disabled, theme.focus]
    }, [`label.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;color:${colors.grey900};font-size:14px;line-height:19px;}`, "label.dense.__jsx-style-dynamic-selector{font-size:14px;line-height:16px;}", `label.disabled.__jsx-style-dynamic-selector{cursor:not-allowed;color:${theme.disabled};}`, "input.__jsx-style-dynamic-selector{opacity:0;position:absolute;height:18px;width:35px;margin-left:3px;}", "label.dense.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{height:14px;width:27px;}", ".icon.__jsx-style-dynamic-selector{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-right:5px;border:2px solid transparent;padding:1px;border-radius:14px;}", "label.dense.__jsx-style-dynamic-selector .icon.__jsx-style-dynamic-selector{margin-right:3px;border-radius:12px;}", `input.__jsx-style-dynamic-selector:focus+.icon.__jsx-style-dynamic-selector{outline:3px solid ${theme.focus};outline-offset:-3px;}`]));
  }
}
_defineProperty(Switch, "defaultProps", {
  checked: false,
  dataTest: 'dhis2-uicore-switch',
  role: 'switch'
});
Switch.propTypes = {
  /** Sets an aria-label attribute on the input */
  'aria-label': PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  /** Makes the switch smaller for information-dense layouts */
  dense: PropTypes.bool,
  /** Disables the switch */
  disabled: PropTypes.bool,
  /** Applies 'error' styles for validation feedback. Mutually exclusive with `valid` and `warning` prop types */
  error: sharedPropTypes.statusPropType,
  /** Grab initial focus on the page */
  initialFocus: PropTypes.bool,
  /** Label for the switch. Can be a string or an element, for example an image */
  label: PropTypes.node,
  /** Name associated with the switch. Passed to event handlers in object */
  name: PropTypes.string,
  /** Sets a role attribute on the input */
  role: PropTypes.string,
  tabIndex: PropTypes.string,
  /** Applies 'valid' styles for validation feedback. Mutually exclusive with `error` and `warning` prop types */
  valid: sharedPropTypes.statusPropType,
  /** Value associated with the switch. Passed to event handlers in object */
  value: PropTypes.string,
  /** Applies 'warning' styles for validation feedback. Mutually exclusive with `valid` and `error` prop types */
  warning: sharedPropTypes.statusPropType,
  /** Called with signature `({ name: string, value: string, checked: bool }, event)` */
  onBlur: PropTypes.func,
  /** Called with signature `({ name: string, value: string, checked: bool }, event)` */
  onChange: PropTypes.func,
  /** Called with signature `({ name: string, value: string, checked: bool }, event)` */
  onFocus: PropTypes.func,
  /** Called with signature `({ name: string, value: string, checked: bool }, event)` */
  onKeyDown: PropTypes.func
};
export { Switch };